module.exports = __webpack_public_path__ + "img/organizations-icon-active.e120c9d0.svg";